import { DialogTitle, Dialog, } from '@material-ui/core';
import styled from 'styled-components';
import colors from '../../../styles/settings/colors';
import fontSize from '../../../styles/settings/fontSize';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: '#F2F1F1';
  overflow-x: hidden;
  width: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 16px;
  position: relative;
  overflow-x: hidden;
  top: 190px;
  width: 100%;
`;

export const TableTitleHeader = styled.div`
  align-items: center;
  background-color: ${colors.sanMarino};
  border-radius: 4px 4px 0 0;
  color: #fff;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  overflow-y: hidden !important;
  padding: 0;

  .operation-title {
    font-size: ${fontSize.headerTable};
    font-weight: bold;
    margin: 0 auto;
    padding: 2px 4px;
  }

  .operation-actions {
    display: flex;
  }

  svg {
    color: white;
    margin-right: 8px;
    width: 15px;
  }
`;

export const DialogModal = styled(Dialog)`
  .MuiDialog-container {
    .MuiDialog-paperWidthSm {
      max-width: max-content;
      
    }
    .MuiDialog-paperWidthMd {
      max-width: max-content;
    }
  }
`;

export const DialogHtmlDiv = styled.div`
padding-right: 20px;
padding-left: 20px;
  table {
    white-space:nowrap;
  }
`;

export const ScrollTable = styled.div`
  .selection-cell-header {
    input[type='checkbox'] {
      margin: 0 4px;
      width: 11px;
      cursor: pointer;
      pointer-events: auto !important;
      z-index: 10;
      position: relative;
    }
  }
  .selection-cell {
    input[type='checkbox'] {
      cursor: pointer;
      pointer-events: auto !important;
      z-index: 10;
      position: relative;
    }
    position: relative;
    z-index: 10;
  }
  &.lateral-table {
    .table {
      font-size: ${fontSize.tableRowText}!important;
      width: -webkit-fill-available;
      thead {
        tr {
          text-align: left;
          white-space: nowrap;
          th {
            white-space: nowrap;
            &:first-child {
              width: 70%;
            }
            &:last-child {
              width: 30%;
            }
          }
        }
      }
      tbody {
        width: 100%;
        tr {
          white-space: nowrap;
          td {
            white-space: nowrap;
            &:first-child {
              cursor: pointer;
              min-width: 70%;
            }
            &:last-child {
              min-width: 30%;
            }
          }
        }
      }
    }
  }

  &.approved-table {
    .table {
      width: auto;
      font-size: ${fontSize.tableRowText}!important;
      width: 100%;
    }
    thead {
      tr {
        white-space: nowrap;
        th {
          white-space: nowrap;
          &:first-child {
            width: 5%;
          }
          &:nth-child(2) {
            width: 65%;
          }
          &:last-child {
            width: 30%;
          }
        }
      }
    }
    tbody {
      tr {
        white-space: nowrap;
        td {
          white-space: nowrap;
          &:first-child {
            position: relative;
            right: 2px;
            width: 5%;
            pointer-events: auto !important;
          }
          &:nth-child(2) {
            width: 65%;
          }
          &:last-child {
            width: 30%;
          }
        }
      }
    }
    .selection-cell {
      pointer-events: auto !important;
      z-index: 10;
      position: relative;
      input[type='checkbox'] {
        pointer-events: auto !important;
        z-index: 11;
        position: relative;
        cursor: pointer;
      }
    }
    .selection-cell-header {
      pointer-events: auto !important;
      z-index: 10;
      position: relative;
      input[type='checkbox'] {
        pointer-events: auto !important;
        z-index: 11;
        position: relative;
        cursor: pointer;
      }
    }
  }

  &.approved-table-rede {
    .table {
      width: auto;
      font-size: ${fontSize.tableRowText}!important;
    }
    thead {
      tr {
        white-space: nowrap;
        th {
          white-space: nowrap;
          &:first-child {
            width: 5%;
          }
          &:nth-child(2) {
            width: 5%;
          }
          &:nth-child(3) {
            width: 25%;
          }
          &:last-child {
            width: 10%;
          }
        }
      }
    }
    tbody {
      tr {
        white-space: nowrap;
        td {
          white-space: nowrap;
          &:first-child {
            position: relative;
            right: 2px;
            width: 5%;
          }
          &:nth-child(2) {
            width: 5%;
          }
          &:nth-child(3) {
            width: 25%;
          }
          &:last-child {
            width: 10%;
          }
        }
      }
    }
  }

  .react-bootstrap-table {
    bottom: 2px;
    position: relative;
    overflow: auto;

    & table {
      table-layout: auto;
    }

    .react-bootstrap-table-sort-order,
    .order {
      display: none;
    }

    .filter.text-filter {
      margin-left: 8px;
    }
    & thead th {
      background: ${colors.sanMarino};
      color: ${colors.white};
      position: sticky;
      text-align: left;
      top: 0;
      z-index: 1;
    }
  }

  .table-striped tbody tr:nth-of-type(odd) {
    background-color: ${colors.oddColor};
  }

  .table-striped tbody tr:nth-of-type(even) {
    background-color: ${colors.evenColor};
  }

  > div {
    max-height: 200px;
    overflow-y: scroll;
  }

  .selection-cell {
    padding: 0px !important;
    right: 0px !important;
  }
`;

export const TableContent = styled.div`
  margin: 16px 0;
`;

// Logo
export const AnchorLogo = styled.div`
  border: 2px solid #424242;
  margin: 0 0 8px;
  background-color: white;
  text-align: center;
  img {
    cursor: pointer;
    height: auto;
    width: auto;
    max-width: 100%;
    max-height: 120px;
  }
`;

export const DialogTitleBg = styled(DialogTitle)`
  background: ${colors.sanMarino};
  color: #fff;
  text-align: center;
`;

export const AnchorOption = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  > div {
    align-items: center;
    border: 1px solid ${colors.white};
    display: flex;
    justify-content: center;
    width: calc(50% - 4px);
    &:hover {
      border: 1px solid ${colors.tundora};
    }
    &.active {
      border: 1px solid #f44336;
    }
    img {
      height: auto;
      padding: 8px;
      width: auto;
      max-width: 100%;
      max-height: 120px;
    }
  }
`;

export const MetasBox = styled.div`
  border-radius: 4px;
  /* box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 1px 5px 0px rgb(0 0 0 / 12%); */
`;

export const MetasContainer = styled.div`
  p {
    margin: 0;
    padding: 0;
  }
  .metas-header {
    background: ${colors.sanMarino};
    color: #fff;
    display: flex;
    flex-flow: row nowrap;
    font-size: ${fontSize.tableRowText};
    font-weight: bold;
    justify-content: space-between;
    padding: 0 8px;
    p:first-child {
      text-align: left;
      width: 32%;
    }
    p {
      border-right: 1px solid white;
      width: 25%;
    }
    p:last-child {
      border-right: 0 solid white;
      text-align: right;
      width: 12%;
    }
  }
  .metas-body {
    display: flex;
    flex-flow: column wrap;
    .metas-body-row {
      align-items: center;
      display: flex;
      flex-flow: row nowrap;
      height: 24px;
      justify-content: space-between;
      font-size: ${fontSize.tableRowText};
      padding: 0 8px;
      &:nth-child(odd) {
        background-color: ${colors.oddColor};
      }
      &:nth-child(even) {
        background-color: ${colors.evenColor};
      }

      p:first-child {
        text-align: left;
        width: 32%;
      }
      p {
        border-right: 1px solid white;
        text-align: right;
        width: 25%;
      }
      p:last-child {
        border-right: 0px solid white;
        text-align: right;
        width: 12%;
      }
    }
  }
`;
